// WorkOrderStatus is a different vocabulary from TaskStatus — do not use TaskService's labels here.
const WORK_ORDER_STATUS = {
  PENDING_REVIEW: { label: 'Pending Review', color: 'secondary' },
  OPEN: { label: 'Open', color: 'info' },
  IN_PROGRESS: { label: 'In Progress', color: 'warning' },
  ON_HOLD: { label: 'On Hold', color: 'warning', variant: 'outlined' },
  COMPLETED: { label: 'Completed', color: 'success' },
  PARTIALLY_INVOICED: { label: 'Partly invoiced', color: 'info' },
  CANCELLED: { label: 'Cancelled', color: 'error' },
  INVOICED: { label: 'Invoiced', color: 'secondary' }
};

export const getWorkOrderStatusConfig = (status) =>
  WORK_ORDER_STATUS[status] || { label: status, color: 'info', variant: 'outlined' };

export const getWorkOrderStatusLabel = (status) => getWorkOrderStatusConfig(status).label;

export default getWorkOrderStatusConfig;
